export default __webpack_public_path__ + "static/media/qr-code-icon.cf35ba19.svg";